'use client';

import { c as _c } from "react/compiler-runtime";
import { useInView } from 'framer-motion';
import { useTranslations } from 'next-intl';
import OptimizedImage from '@/components/OptimizedImage';
import { useRef } from 'react';
import IconDiscord from '@/components/assets/icon_discord.svg';
import ViverseButton from '@/components/ViverseButton';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import ImageRecapVektor from '@/public/images/creator-intro/recap-vector.png';
function Recap() {
  const $ = _c(33);
  const t = useTranslations();
  const ref = useRef(null);
  const isInView = useInView(ref);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      background: "linear-gradient(90deg, #903BFF 0%, #DB40DB 100%)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("creator-intro.recap.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="header-3 lg:header-2 text-center lg:leading-[40px]">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("creator-intro.recap.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="subheader-1 text-center leading-[32px] font-[400]">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("creator-intro.recap.cta-1");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Link target="_blank" href="https://docs.viverse.com/"><ViverseButton size="filter" variant="default" className="1.5xl:h-[34px] 1.5xl:px-4 1.5xl:py-[6px] z-interactive flex h-[48px] items-center py-3 text-[14px] whitespace-normal">{t5}</ViverseButton></Link>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconDiscord className="mr-2 size-4" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("creator-intro.recap.cta-2");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Link target="_blank" href="https://discord.gg/viversecreators"><ViverseButton size="filter" variant="secondary" className="1.5xl:h-[34px] 1.5xl:px-4 1.5xl:py-[6px] flex h-[48px] items-center py-3 text-[14px] whitespace-normal">{t7}{t8}</ViverseButton></Link>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="m-auto flex flex-col items-center gap-4 md:flex-row">{t6}{t9}</div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t4) {
    t11 = <span className="1.5xl:max-w-[620px] 1.5xl:py-6 3xl:max-w-[900px] m-auto flex flex-col gap-4">{t2}{t4}{t10}</span>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const t12 = isInView ? "opacity-100" : "opacity-0";
  let t13;
  if ($[25] !== t12) {
    t13 = cn("pointer-events-none object-cover", t12);
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      background: "linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(252, 220, 123, 0.1) 100%)"
    };
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13) {
    t15 = <OptimizedImage className={t13} fill={true} sizes="100vw" src={ImageRecapVektor} alt="viverse-vektor" style={t14} />;
    $[28] = t13;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t15) {
    t16 = <section ref={ref} className="1.5xl:pb-[80px] 1.5xl:pt-[40px] 3xl:px-[120px] relative flex flex-1 flex-col justify-center gap-[48px] px-4 py-8 md:gap-[80px] md:px-[40px]"><div className="relative m-auto flex w-full flex-1 overflow-hidden rounded-3xl px-4 py-[80px]" style={t0}>{t11}{t15}</div></section>;
    $[30] = t11;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
}
export default Recap;